

document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".tab-button");
    const contents = document.querySelectorAll(".tab-content");

    function activateTab(tabId) {
        // Remove 'active' class from all buttons
        buttons.forEach(btn => btn.classList.remove("active"));

        // Hide all tab contents
        contents.forEach(content => {
            content.classList.remove("active");
            content.style.display = "none";
        });

        // Add 'active' class to clicked button
        const activeButton = document.querySelector(`.tab-button[data-tab-id="${tabId}"]`);
        if (activeButton) activeButton.classList.add("active");

        // Show all contents related to the clicked tab
        const activeContents = document.querySelectorAll(`.tab-content[data-tab-id="${tabId}"]`);
        activeContents.forEach(content => {
            content.classList.add("active");
            content.style.display = "block";
        });
    }

    // Set first tab as active by default
    if (buttons.length > 0) {
        const firstTabId = buttons[0].getAttribute("data-tab-id");
        activateTab(firstTabId);
    }

    // Click event for tabs
    buttons.forEach(button => {
        button.addEventListener("click", function () {
            const tabId = this.getAttribute("data-tab-id");
            activateTab(tabId);
        });
    });
});







$('document').ready(function() {




  $('.reviews-wrapper').slick({
    dots: false,
    infinite: true,
    speed: 500, // Slower transition speed
    autoplay: false,
    autoplaySpeed: 5000, // Keeps continuous movement
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 768, // Breakpoint for mobile devices
            settings: {
                slidesToShow: 1
            }
        }
    ]
  });


$('.marquee-slider-mian').slick({
  slidesToShow: 1, // Number of slides visible at once
  slidesToScroll: 1, // Number of slides to scroll at a time
  autoplay: true, // Enable autoplay
  autoplaySpeed: 0, // Set autoplay speed (0 for continuous scrolling)
  speed: 10000, // Speed of the scrolling
  arrows: false, // Hide arrows
  dots: false, // Hide dots
  infinite: true, // Enable infinite loop
  variableWidth: true, // Allow variable width for seamless scrolling
  cssEase: 'linear', // Linear animation for smooth scrolling
});






  


 $('.testimonial-sliders').slick({
  centerMode: true,
  arrows: true,
  infinite: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToScroll: 1,
  slidesToShow: 1, // Adjusted this to 4
  responsive: [
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        infinite: true,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    }
  ]
});




 function openTab(evt, tabId) {
    // Sabhi tab buttons se active class remove karna
    $('.tab-link-ps').removeClass('active-ps');

    // Jo button click hua hai, usme active class add karna
    $(evt.currentTarget).addClass('active-ps');

    // Sabhi tab content ko hide karna
    $('.tab-pane-ps').removeClass('active-ps').hide();

    // Selected tab ko show karna
    $('#' + tabId).addClass('active-ps').fadeIn();

    // // Slick slider initialize karna agar abhi tak initialize nahi hua
    // let $slider = $('#' + tabId).find('.products-grid-ps');
    // if (!$slider.hasClass('slick-initialized')) {
    //   $slider.slick({
    //     arrows: true,
    //     infinite: false,
    //     speed: 300,
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     responsive: [
    //       {
    //         breakpoint: 480,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1
    //         }
    //       }
    //     ]
    //   });
    // }
  }

  // Default pehle tab open karna
  $('.tab-link-ps:first').addClass('active-ps');
  $('.tab-pane-ps:first').addClass('active-ps').show();

  // Click event bind karna
  $('.tab-link-ps').on('click', function (event) {
    let tabId = $(this).attr('onclick').match(/'([^']+)'/)[1];
    openTab(event, tabId);
  });




  
  


  
});




